import { Order, OrderItem } from '../types';

export const mockOrderItems: OrderItem[] = [
  {
    id: '1050e8400-e29b-41d4-a716-446655440001',
    orderId: '1000e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440003',
    feeName: 'Art Supplies Kit',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 75.00,
    totalPrice: 75.00,
    createdAt: new Date('2024-09-01T10:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440002',
    orderId: '1000e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440011',
    feeName: 'PE Uniform Set',
    feeCategory: 'General Fees',
    quantity: 2,
    pricingTier: 'full',
    unitPrice: 35.00,
    totalPrice: 70.00,
    createdAt: new Date('2024-09-01T10:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440003',
    orderId: '1000e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440001',
    feeName: 'Monthly Bus Pass',
    feeCategory: 'Transportation',
    quantity: 1,
    pricingTier: 'reduced',
    unitPrice: 25.00,
    totalPrice: 25.00,
    createdAt: new Date('2024-09-02T14:15:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440004',
    orderId: '1000e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440061',
    feeName: 'Varsity Basketball vs. Central High',
    feeCategory: 'Event Tickets',
    quantity: 4,
    pricingTier: 'full',
    unitPrice: 8.00,
    totalPrice: 32.00,
    createdAt: new Date('2024-09-05T16:45:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440005',
    orderId: '1000e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440010',
    feeName: 'Yearbook',
    feeCategory: 'General Fees',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 65.00,
    totalPrice: 65.00,
    partialPaymentAmount: 30.00,
    createdAt: new Date('2024-09-10T09:20:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440006',
    orderId: '1000e8400-e29b-41d4-a716-446655440005',
    feeId: '850e8400-e29b-41d4-a716-446655440005',
    feeName: 'Graphing Calculator',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 125.00,
    totalPrice: 125.00,
    partialPaymentAmount: 50.00,
    createdAt: new Date('2024-09-12T11:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440007',
    orderId: '1000e8400-e29b-41d4-a716-446655440006',
    feeId: '850e8400-e29b-41d4-a716-446655440006',
    feeName: 'Science Museum Trip',
    feeCategory: 'Field Trips',
    quantity: 1,
    pricingTier: 'free',
    unitPrice: 0.00,
    totalPrice: 0.00,
    questionnaireResponses: {
      'dietary_restrictions': 'None',
      'emergency_contact': 'Jane Williams - 555-0123',
    },
    signatureData: {
      accepted: true,
      signedBy: 'Jane Williams',
      signedAt: new Date('2024-09-15T08:00:00'),
    },
    createdAt: new Date('2024-09-15T08:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440008',
    orderId: '1000e8400-e29b-41d4-a716-446655440007',
    feeId: '850e8400-e29b-41d4-a716-446655440008',
    feeName: 'Spring Concert Ticket',
    feeCategory: 'Event Tickets',
    quantity: 6,
    pricingTier: 'full',
    unitPrice: 12.00,
    totalPrice: 72.00,
    createdAt: new Date('2024-09-18T13:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440009',
    orderId: '1000e8400-e29b-41d4-a716-446655440008',
    feeId: '850e8400-e29b-41d4-a716-446655440012',
    feeName: 'Parking Permit',
    feeCategory: 'General Fees',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 150.00,
    totalPrice: 150.00,
    partialPaymentAmount: 75.00,
    createdAt: new Date('2024-09-20T15:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440010',
    orderId: '1000e8400-e29b-41d4-a716-446655440009',
    feeId: '850e8400-e29b-41d4-a716-446655440022',
    feeName: 'Spanish Workbook Set',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'reduced',
    unitPrice: 21.00,
    totalPrice: 21.00,
    createdAt: new Date('2024-09-22T10:15:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440011',
    orderId: '1000e8400-e29b-41d4-a716-446655440010',
    feeId: '850e8400-e29b-41d4-a716-446655440062',
    feeName: 'Varsity Football Championship Game',
    feeCategory: 'Event Tickets',
    quantity: 8,
    pricingTier: 'full',
    unitPrice: 15.00,
    totalPrice: 120.00,
    createdAt: new Date('2024-09-25T17:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440012',
    orderId: '1000e8400-e29b-41d4-a716-446655440011',
    feeId: '850e8400-e29b-41d4-a716-446655440035',
    feeName: 'Digital Textbook Bundle',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 250.00,
    totalPrice: 250.00,
    partialPaymentAmount: 125.00,
    createdAt: new Date('2024-10-01T09:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440013',
    orderId: '1000e8400-e29b-41d4-a716-446655440012',
    feeId: '850e8400-e29b-41d4-a716-446655440040',
    feeName: 'Welding Course Materials',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'reduced',
    unitPrice: 67.50,
    totalPrice: 67.50,
    createdAt: new Date('2024-10-05T11:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440014',
    orderId: '1000e8400-e29b-41d4-a716-446655440013',
    feeId: '850e8400-e29b-41d4-a716-446655440048',
    feeName: 'Graphic Design Software',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 180.00,
    totalPrice: 180.00,
    partialPaymentAmount: 90.00,
    createdAt: new Date('2024-10-08T14:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440015',
    orderId: '1000e8400-e29b-41d4-a716-446655440014',
    feeId: '850e8400-e29b-41d4-a716-446655440053',
    feeName: 'SAT Prep Course',
    feeCategory: 'General Fees',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 299.00,
    totalPrice: 299.00,
    partialPaymentAmount: 149.50,
    createdAt: new Date('2024-10-10T16:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440016',
    orderId: '1000e8400-e29b-41d4-a716-446655440015',
    feeId: '850e8400-e29b-41d4-a716-446655440007',
    feeName: 'Historical Society Trip',
    feeCategory: 'Field Trips',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 28.00,
    totalPrice: 28.00,
    questionnaireResponses: {
      'dietary_restrictions': 'Vegetarian',
      'emergency_contact': 'Robert Brown - 555-0456',
    },
    signatureData: {
      accepted: true,
      signedBy: 'Robert Brown',
      signedAt: new Date('2024-10-12T09:30:00'),
    },
    createdAt: new Date('2024-10-12T09:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440017',
    orderId: '1000e8400-e29b-41d4-a716-446655440016',
    feeId: '850e8400-e29b-41d4-a716-446655440020',
    feeName: 'Robotics Club Fee',
    feeCategory: 'General Fees',
    quantity: 1,
    pricingTier: 'reduced',
    unitPrice: 55.00,
    totalPrice: 55.00,
    createdAt: new Date('2024-10-15T12:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440018',
    orderId: '1000e8400-e29b-41d4-a716-446655440017',
    feeId: '850e8400-e29b-41d4-a716-446655440064',
    feeName: 'Varsity Swimming Meet - District Finals',
    feeCategory: 'Event Tickets',
    quantity: 5,
    pricingTier: 'full',
    unitPrice: 10.00,
    totalPrice: 50.00,
    createdAt: new Date('2024-10-18T15:45:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440019',
    orderId: '1000e8400-e29b-41d4-a716-446655440018',
    feeId: '850e8400-e29b-41d4-a716-446655440031',
    feeName: 'Senior Prom Ticket',
    feeCategory: 'Event Tickets',
    quantity: 2,
    pricingTier: 'full',
    unitPrice: 75.00,
    totalPrice: 150.00,
    createdAt: new Date('2024-10-20T11:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440020',
    orderId: '1000e8400-e29b-41d4-a716-446655440019',
    feeId: '850e8400-e29b-41d4-a716-446655440057',
    feeName: 'Graduation Cap and Gown',
    feeCategory: 'General Fees',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 85.00,
    totalPrice: 85.00,
    createdAt: new Date('2024-10-22T13:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440021',
    orderId: '1000e8400-e29b-41d4-a716-446655440020',
    feeId: '850e8400-e29b-41d4-a716-446655440026',
    feeName: 'Culinary Arts Supplies',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'free',
    unitPrice: 0.00,
    totalPrice: 0.00,
    createdAt: new Date('2024-10-25T10:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440022',
    orderId: '1000e8400-e29b-41d4-a716-446655440021',
    feeId: '850e8400-e29b-41d4-a716-446655440002',
    feeName: 'Semester Bus Pass',
    feeCategory: 'Transportation',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 225.00,
    totalPrice: 225.00,
    partialPaymentAmount: 112.50,
    createdAt: new Date('2024-10-28T08:45:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440023',
    orderId: '1000e8400-e29b-41d4-a716-446655440022',
    feeId: '850e8400-e29b-41d4-a716-446655440066',
    feeName: 'Girls Basketball Tournament',
    feeCategory: 'Event Tickets',
    quantity: 10,
    pricingTier: 'full',
    unitPrice: 12.00,
    totalPrice: 120.00,
    createdAt: new Date('2024-11-01T14:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440024',
    orderId: '1000e8400-e29b-41d4-a716-446655440023',
    feeId: '850e8400-e29b-41d4-a716-446655440037',
    feeName: 'Physics Lab Equipment',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'reduced',
    unitPrice: 34.00,
    totalPrice: 34.00,
    createdAt: new Date('2024-11-05T09:15:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440025',
    orderId: '1000e8400-e29b-41d4-a716-446655440024',
    feeId: '850e8400-e29b-41d4-a716-446655440043',
    feeName: 'Psychology Study Materials',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 52.00,
    totalPrice: 52.00,
    createdAt: new Date('2024-11-08T11:45:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440026',
    orderId: '1000e8400-e29b-41d4-a716-446655440025',
    feeId: '850e8400-e29b-41d4-a716-446655440032',
    feeName: 'Homecoming Dance Ticket',
    feeCategory: 'Event Tickets',
    quantity: 2,
    pricingTier: 'full',
    unitPrice: 35.00,
    totalPrice: 70.00,
    createdAt: new Date('2024-11-10T16:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440027',
    orderId: '1000e8400-e29b-41d4-a716-446655440026',
    feeId: '850e8400-e29b-41d4-a716-446655440039',
    feeName: 'Computer Science Software License',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'reduced',
    unitPrice: 27.50,
    totalPrice: 27.50,
    createdAt: new Date('2024-11-12T10:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440028',
    orderId: '1000e8400-e29b-41d4-a716-446655440027',
    feeId: '850e8400-e29b-41d4-a716-446655440046',
    feeName: 'Ceramics Class Materials',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 92.00,
    totalPrice: 92.00,
    partialPaymentAmount: 46.00,
    createdAt: new Date('2024-11-15T13:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440029',
    orderId: '1000e8400-e29b-41d4-a716-446655440028',
    feeId: '850e8400-e29b-41d4-a716-446655440050',
    feeName: 'STEM Competition Entry',
    feeCategory: 'Field Trips',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 45.00,
    totalPrice: 45.00,
    questionnaireResponses: {
      'team_members': 'Alex Johnson, Sarah Lee, Mike Chen',
      'project_title': 'Smart Water Conservation System',
    },
    createdAt: new Date('2024-11-18T09:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440030',
    orderId: '1000e8400-e29b-41d4-a716-446655440029',
    feeId: '850e8400-e29b-41d4-a716-446655440056',
    feeName: 'Winter Formal Ticket',
    feeCategory: 'Event Tickets',
    quantity: 2,
    pricingTier: 'full',
    unitPrice: 45.00,
    totalPrice: 90.00,
    createdAt: new Date('2024-12-01T12:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440031',
    orderId: '1000e8400-e29b-41d4-a716-446655440030',
    feeId: '850e8400-e29b-41d4-a716-446655440004',
    feeName: 'Science Lab Materials',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 58.00,
    totalPrice: 58.00,
    createdAt: new Date('2024-12-03T10:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440032',
    orderId: '1000e8400-e29b-41d4-a716-446655440030',
    feeId: '850e8400-e29b-41d4-a716-446655440036',
    feeName: 'Calculus Study Materials',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 38.00,
    totalPrice: 38.00,
    createdAt: new Date('2024-12-03T10:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440033',
    orderId: '1000e8400-e29b-41d4-a716-446655440031',
    feeId: '850e8400-e29b-41d4-a716-446655440003',
    feeName: 'Art Supplies Kit',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 75.00,
    totalPrice: 75.00,
    createdAt: new Date('2026-01-02T09:15:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440034',
    orderId: '1000e8400-e29b-41d4-a716-446655440032',
    feeId: '850e8400-e29b-41d4-a716-446655440005',
    feeName: 'Graphing Calculator',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 125.00,
    totalPrice: 125.00,
    createdAt: new Date('2026-01-03T14:20:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440035',
    orderId: '1000e8400-e29b-41d4-a716-446655440033',
    feeId: '850e8400-e29b-41d4-a716-446655440061',
    feeName: 'Varsity Basketball vs. Central High',
    feeCategory: 'Event Tickets',
    quantity: 5,
    pricingTier: 'full',
    unitPrice: 12.00,
    totalPrice: 60.00,
    createdAt: new Date('2026-01-04T11:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440036',
    orderId: '1000e8400-e29b-41d4-a716-446655440034',
    feeId: '850e8400-e29b-41d4-a716-446655440010',
    feeName: 'Yearbook',
    feeCategory: 'General Fees',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 65.00,
    totalPrice: 65.00,
    createdAt: new Date('2026-01-04T15:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440037',
    orderId: '1000e8400-e29b-41d4-a716-446655440034',
    feeId: '850e8400-e29b-41d4-a716-446655440022',
    feeName: 'Spanish Workbook Set',
    feeCategory: 'Class Materials & Supplies',
    quantity: 1,
    pricingTier: 'reduced',
    unitPrice: 24.00,
    totalPrice: 24.00,
    createdAt: new Date('2026-01-04T15:30:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440038',
    orderId: '1000e8400-e29b-41d4-a716-446655440035',
    feeId: '850e8400-e29b-41d4-a716-446655440062',
    feeName: 'Varsity Football Championship Game',
    feeCategory: 'Event Tickets',
    quantity: 4,
    pricingTier: 'full',
    unitPrice: 12.00,
    totalPrice: 48.00,
    createdAt: new Date('2026-01-05T10:00:00'),
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440039',
    orderId: '1000e8400-e29b-41d4-a716-446655440036',
    feeId: '850e8400-e29b-41d4-a716-446655440019',
    feeName: 'Student Activity Pass',
    feeCategory: 'Events & Activities',
    quantity: 1,
    pricingTier: 'full',
    unitPrice: 75.00,
    totalPrice: 75.00,
    createdAt: new Date('2025-09-05T10:30:00'),
  },
];

export const mockOrders: Order[] = [
  {
    id: '1000e8400-e29b-41d4-a716-446655440001',
    orderNumber: 'ORD-2024-00001',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    userName: 'Emma Johnson',
    userEmail: 'emma.johnson@school.edu',
    subtotal: 145.00,
    tax: 11.60,
    total: 156.60,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-001',
    createdAt: new Date('2024-09-01T10:30:00'),
    completedAt: new Date('2024-09-01T10:31:45'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440002',
    orderNumber: 'ORD-2024-00002',
    userId: '650e8400-e29b-41d4-a716-446655440002',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    userType: 'parent',
    userName: 'Sarah Smith',
    userEmail: 'sarah.smith@email.com',
    subtotal: 25.00,
    tax: 2.00,
    total: 27.00,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-002',
    createdAt: new Date('2024-09-02T14:15:00'),
    completedAt: new Date('2024-09-02T14:16:30'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440003',
    orderNumber: 'ORD-2024-00003',
    userId: '250e8400-e29b-41d4-a716-446655440001',
    userType: 'community',
    userName: 'Michael Anderson',
    userEmail: 'michael.anderson@email.com',
    subtotal: 32.00,
    tax: 2.56,
    total: 34.56,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-003',
    createdAt: new Date('2024-09-05T16:45:00'),
    completedAt: new Date('2024-09-05T16:46:20'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440004',
    orderNumber: 'ORD-2024-00004',
    userId: '550e8400-e29b-41d4-a716-446655440004',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    userType: 'student',
    userName: 'Noah Brown',
    userEmail: 'noah.brown@school.edu',
    subtotal: 65.00,
    tax: 5.20,
    total: 70.20,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-004',
    notes: 'Partial payment of $30 applied',
    createdAt: new Date('2024-09-10T09:20:00'),
    completedAt: new Date('2024-09-10T09:21:15'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440005',
    orderNumber: 'ORD-2024-00005',
    userId: '650e8400-e29b-41d4-a716-446655440004',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    userType: 'parent',
    userName: 'Robert Brown',
    userEmail: 'robert.brown@email.com',
    subtotal: 125.00,
    tax: 10.00,
    total: 135.00,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-005',
    notes: 'Partial payment of $50 applied',
    createdAt: new Date('2024-09-12T11:00:00'),
    completedAt: new Date('2024-09-12T11:01:30'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440006',
    orderNumber: 'ORD-2024-00006',
    userId: '650e8400-e29b-41d4-a716-446655440003',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    userType: 'parent',
    userName: 'Jane Williams',
    userEmail: 'jane.williams@email.com',
    subtotal: 0.00,
    tax: 0.00,
    total: 0.00,
    paymentStatus: 'completed',
    paymentMethod: 'N/A',
    notes: 'Free tier - field trip waiver submitted',
    createdAt: new Date('2024-09-15T08:00:00'),
    completedAt: new Date('2024-09-15T08:02:00'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440007',
    orderNumber: 'ORD-2024-00007',
    userId: '250e8400-e29b-41d4-a716-446655440002',
    userType: 'community',
    userName: 'Emily Davis',
    userEmail: 'emily.davis@email.com',
    subtotal: 72.00,
    tax: 5.76,
    total: 77.76,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-007',
    createdAt: new Date('2024-09-18T13:30:00'),
    completedAt: new Date('2024-09-18T13:31:45'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440008',
    orderNumber: 'ORD-2024-00008',
    userId: '550e8400-e29b-41d4-a716-446655440005',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    userType: 'student',
    userName: 'Ava Davis',
    userEmail: 'ava.davis@school.edu',
    subtotal: 150.00,
    tax: 12.00,
    total: 162.00,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-008',
    notes: 'Partial payment of $75 applied',
    createdAt: new Date('2024-09-20T15:00:00'),
    completedAt: new Date('2024-09-20T15:01:20'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440009',
    orderNumber: 'ORD-2024-00009',
    userId: '550e8400-e29b-41d4-a716-446655440002',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    userType: 'student',
    userName: 'Liam Smith',
    userEmail: 'liam.smith@school.edu',
    subtotal: 21.00,
    tax: 1.68,
    total: 22.68,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-009',
    createdAt: new Date('2024-09-22T10:15:00'),
    completedAt: new Date('2024-09-22T10:16:10'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440010',
    orderNumber: 'ORD-2024-00010',
    userType: 'guest',
    userName: 'Christopher Martinez',
    userEmail: 'chris.martinez@email.com',
    subtotal: 120.00,
    tax: 9.60,
    total: 129.60,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-010',
    createdAt: new Date('2024-09-25T17:00:00'),
    completedAt: new Date('2024-09-25T17:01:30'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440011',
    orderNumber: 'ORD-2024-00011',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    userName: 'Emma Johnson',
    userEmail: 'emma.johnson@school.edu',
    subtotal: 250.00,
    tax: 20.00,
    total: 270.00,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-011',
    notes: 'Partial payment of $125 applied',
    createdAt: new Date('2024-10-01T09:00:00'),
    completedAt: new Date('2024-10-01T09:01:45'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440012',
    orderNumber: 'ORD-2024-00012',
    userId: '550e8400-e29b-41d4-a716-446655440005',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    userType: 'student',
    userName: 'Ava Davis',
    userEmail: 'ava.davis@school.edu',
    subtotal: 67.50,
    tax: 5.40,
    total: 72.90,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-012',
    createdAt: new Date('2024-10-05T11:30:00'),
    completedAt: new Date('2024-10-05T11:31:20'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440013',
    orderNumber: 'ORD-2024-00013',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    userName: 'Emma Johnson',
    userEmail: 'emma.johnson@school.edu',
    subtotal: 180.00,
    tax: 14.40,
    total: 194.40,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-013',
    notes: 'Partial payment of $90 applied',
    createdAt: new Date('2024-10-08T14:00:00'),
    completedAt: new Date('2024-10-08T14:01:30'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440014',
    orderNumber: 'ORD-2024-00014',
    userId: '650e8400-e29b-41d4-a716-446655440005',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    userType: 'parent',
    userName: 'Jennifer Davis',
    userEmail: 'jennifer.davis@email.com',
    subtotal: 299.00,
    tax: 23.92,
    total: 322.92,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-014',
    notes: 'Partial payment of $149.50 applied',
    createdAt: new Date('2024-10-10T16:00:00'),
    completedAt: new Date('2024-10-10T16:01:50'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440015',
    orderNumber: 'ORD-2024-00015',
    userId: '650e8400-e29b-41d4-a716-446655440004',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    userType: 'parent',
    userName: 'Robert Brown',
    userEmail: 'robert.brown@email.com',
    subtotal: 28.00,
    tax: 2.24,
    total: 30.24,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-015',
    notes: 'Field trip waiver submitted',
    createdAt: new Date('2024-10-12T09:30:00'),
    completedAt: new Date('2024-10-12T09:32:00'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440016',
    orderNumber: 'ORD-2024-00016',
    userId: '550e8400-e29b-41d4-a716-446655440005',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    userType: 'student',
    userName: 'Ava Davis',
    userEmail: 'ava.davis@school.edu',
    subtotal: 55.00,
    tax: 4.40,
    total: 59.40,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-016',
    createdAt: new Date('2024-10-15T12:00:00'),
    completedAt: new Date('2024-10-15T12:01:15'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440017',
    orderNumber: 'ORD-2024-00017',
    userType: 'guest',
    userName: 'Patricia Thompson',
    userEmail: 'patricia.thompson@email.com',
    subtotal: 50.00,
    tax: 4.00,
    total: 54.00,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-017',
    createdAt: new Date('2024-10-18T15:45:00'),
    completedAt: new Date('2024-10-18T15:46:30'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440018',
    orderNumber: 'ORD-2024-00018',
    userId: '650e8400-e29b-41d4-a716-446655440005',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    userType: 'parent',
    userName: 'Jennifer Davis',
    userEmail: 'jennifer.davis@email.com',
    subtotal: 150.00,
    tax: 12.00,
    total: 162.00,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-018',
    createdAt: new Date('2024-10-20T11:00:00'),
    completedAt: new Date('2024-10-20T11:01:30'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440019',
    orderNumber: 'ORD-2024-00019',
    userId: '550e8400-e29b-41d4-a716-446655440005',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    userType: 'student',
    userName: 'Ava Davis',
    userEmail: 'ava.davis@school.edu',
    subtotal: 85.00,
    tax: 6.80,
    total: 91.80,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-019',
    createdAt: new Date('2024-10-22T13:30:00'),
    completedAt: new Date('2024-10-22T13:31:20'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440020',
    orderNumber: 'ORD-2024-00020',
    userId: '550e8400-e29b-41d4-a716-446655440003',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    userType: 'student',
    userName: 'Olivia Williams',
    userEmail: 'olivia.williams@school.edu',
    subtotal: 0.00,
    tax: 0.00,
    total: 0.00,
    paymentStatus: 'completed',
    paymentMethod: 'N/A',
    notes: 'Free tier',
    createdAt: new Date('2024-10-25T10:00:00'),
    completedAt: new Date('2024-10-25T10:01:00'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440021',
    orderNumber: 'ORD-2024-00021',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    userName: 'Emma Johnson',
    userEmail: 'emma.johnson@school.edu',
    subtotal: 225.00,
    tax: 18.00,
    total: 243.00,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-021',
    notes: 'Partial payment of $112.50 applied',
    createdAt: new Date('2024-10-28T08:45:00'),
    completedAt: new Date('2024-10-28T08:46:40'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440022',
    orderNumber: 'ORD-2024-00022',
    userType: 'guest',
    userName: 'David Wilson',
    userEmail: 'david.wilson@email.com',
    subtotal: 120.00,
    tax: 9.60,
    total: 129.60,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-022',
    createdAt: new Date('2024-11-01T14:00:00'),
    completedAt: new Date('2024-11-01T14:01:30'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440023',
    orderNumber: 'ORD-2024-00023',
    userId: '550e8400-e29b-41d4-a716-446655440002',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    userType: 'student',
    userName: 'Liam Smith',
    userEmail: 'liam.smith@school.edu',
    subtotal: 34.00,
    tax: 2.72,
    total: 36.72,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-023',
    createdAt: new Date('2024-11-05T09:15:00'),
    completedAt: new Date('2024-11-05T09:16:10'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440024',
    orderNumber: 'ORD-2024-00024',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    userName: 'Emma Johnson',
    userEmail: 'emma.johnson@school.edu',
    subtotal: 52.00,
    tax: 4.16,
    total: 56.16,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-024',
    createdAt: new Date('2024-11-08T11:45:00'),
    completedAt: new Date('2024-11-08T11:46:20'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440025',
    orderNumber: 'ORD-2024-00025',
    userType: 'guest',
    userName: 'Lisa Anderson',
    userEmail: 'lisa.anderson@email.com',
    subtotal: 70.00,
    tax: 5.60,
    total: 75.60,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-025',
    createdAt: new Date('2024-11-10T16:30:00'),
    completedAt: new Date('2024-11-10T16:31:40'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440026',
    orderNumber: 'ORD-2024-00026',
    userId: '550e8400-e29b-41d4-a716-446655440005',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    userType: 'student',
    userName: 'Ava Davis',
    userEmail: 'ava.davis@school.edu',
    subtotal: 27.50,
    tax: 2.20,
    total: 29.70,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-026',
    createdAt: new Date('2024-11-12T10:00:00'),
    completedAt: new Date('2024-11-12T10:01:15'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440027',
    orderNumber: 'ORD-2024-00027',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    userName: 'Emma Johnson',
    userEmail: 'emma.johnson@school.edu',
    subtotal: 92.00,
    tax: 7.36,
    total: 99.36,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-027',
    notes: 'Partial payment of $46 applied',
    createdAt: new Date('2024-11-15T13:00:00'),
    completedAt: new Date('2024-11-15T13:01:30'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440028',
    orderNumber: 'ORD-2024-00028',
    userId: '550e8400-e29b-41d4-a716-446655440004',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    userType: 'student',
    userName: 'Noah Brown',
    userEmail: 'noah.brown@school.edu',
    subtotal: 45.00,
    tax: 3.60,
    total: 48.60,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-028',
    notes: 'STEM Competition registration with questionnaire',
    createdAt: new Date('2024-11-18T09:30:00'),
    completedAt: new Date('2024-11-18T09:32:00'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440029',
    orderNumber: 'ORD-2024-00029',
    userType: 'guest',
    userName: 'Thomas Clark',
    userEmail: 'thomas.clark@email.com',
    subtotal: 90.00,
    tax: 7.20,
    total: 97.20,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2024-029',
    createdAt: new Date('2024-12-01T12:00:00'),
    completedAt: new Date('2024-12-01T12:01:30'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440030',
    orderNumber: 'ORD-2024-00030',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    userName: 'Emma Johnson',
    userEmail: 'emma.johnson@school.edu',
    subtotal: 96.00,
    tax: 7.68,
    total: 103.68,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2024-030',
    createdAt: new Date('2024-12-03T10:30:00'),
    completedAt: new Date('2024-12-03T10:31:45'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440031',
    orderNumber: 'ORD-2026-00031',
    userId: '550e8400-e29b-41d4-a716-446655440002',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    userType: 'student',
    userName: 'Liam Smith',
    userEmail: 'liam.smith@school.edu',
    subtotal: 75.00,
    tax: 6.00,
    total: 81.00,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2026-001',
    createdAt: new Date('2026-01-02T09:15:00'),
    completedAt: new Date('2026-01-02T09:16:30'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440032',
    orderNumber: 'ORD-2026-00032',
    userId: '650e8400-e29b-41d4-a716-446655440001',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'parent',
    userName: 'Michael Johnson',
    userEmail: 'michael.johnson@email.com',
    subtotal: 125.00,
    tax: 10.00,
    total: 135.00,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2026-002',
    createdAt: new Date('2026-01-03T14:20:00'),
    completedAt: new Date('2026-01-03T14:21:45'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440033',
    orderNumber: 'ORD-2026-00033',
    userType: 'guest',
    userName: 'Jennifer Martinez',
    userEmail: 'jennifer.martinez@email.com',
    subtotal: 60.00,
    tax: 4.80,
    total: 64.80,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2026-003',
    createdAt: new Date('2026-01-04T11:00:00'),
    completedAt: new Date('2026-01-04T11:01:20'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440034',
    orderNumber: 'ORD-2026-00034',
    userId: '550e8400-e29b-41d4-a716-446655440003',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    userType: 'student',
    userName: 'Olivia Williams',
    userEmail: 'olivia.williams@school.edu',
    subtotal: 89.00,
    tax: 7.12,
    total: 96.12,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    transactionId: 'TXN-2026-004',
    createdAt: new Date('2026-01-04T15:30:00'),
    completedAt: new Date('2026-01-04T15:31:40'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440035',
    orderNumber: 'ORD-2026-00035',
    userId: '250e8400-e29b-41d4-a716-446655440003',
    userType: 'community',
    userName: 'Robert Taylor',
    userEmail: 'robert.taylor@email.com',
    subtotal: 48.00,
    tax: 3.84,
    total: 51.84,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2026-005',
    createdAt: new Date('2026-01-05T10:00:00'),
    completedAt: new Date('2026-01-05T10:01:30'),
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440036',
    orderNumber: 'ORD-2025-00036',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    userName: 'Emma Johnson',
    userEmail: 'emma.johnson@school.edu',
    subtotal: 75.00,
    tax: 6.00,
    total: 81.00,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2025-036',
    notes: 'Student Activity Pass - Full year access to events',
    createdAt: new Date('2025-09-05T10:30:00'),
    completedAt: new Date('2025-09-05T10:31:45'),
    items: [
      {
        id: '1050e8400-e29b-41d4-a716-446655440039',
        orderId: '1000e8400-e29b-41d4-a716-446655440036',
        feeId: '850e8400-e29b-41d4-a716-446655440019',
        feeName: 'Student Activity Pass',
        feeCategory: 'Events & Activities',
        quantity: 1,
        pricingTier: 'full',
        unitPrice: 75.00,
        totalPrice: 75.00,
        createdAt: new Date('2025-09-05T10:30:00'),
      },
    ],
  },
  // ─── Demo purchases for Lisa Johnson (parent, multi-student) ────────────
  // User id 650e8400-...-440006; manages Emma (...-440001) + Liam (...-440002).
  // These populate the Purchases screen for the booth tour.
  {
    id: '1000e8400-e29b-41d4-a716-446655440101',
    orderNumber: 'ORD-2025-00101',
    userId: '650e8400-e29b-41d4-a716-446655440006',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'parent',
    userName: 'Lisa Johnson',
    userEmail: 'lisa.johnson@email.com',
    subtotal: 40.00,
    tax: 3.20,
    total: 43.20,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2025-101',
    notes: 'Spring Concert — 4 tickets',
    createdAt: new Date('2026-03-15T09:12:00'),
    completedAt: new Date('2026-03-15T09:12:45'),
    items: [
      {
        id: '1050e8400-e29b-41d4-a716-446655440101',
        orderId: '1000e8400-e29b-41d4-a716-446655440101',
        feeId: '850e8400-e29b-41d4-a716-446655440008',
        feeName: 'Spring Concert Ticket',
        feeCategory: 'Event Tickets',
        quantity: 4,
        pricingTier: 'full',
        unitPrice: 10.00,
        totalPrice: 40.00,
        createdAt: new Date('2026-03-15T09:12:00'),
      },
    ],
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440102',
    orderNumber: 'ORD-2025-00102',
    userId: '650e8400-e29b-41d4-a716-446655440006',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    userType: 'parent',
    userName: 'Lisa Johnson',
    userEmail: 'lisa.johnson@email.com',
    subtotal: 32.00,
    tax: 2.56,
    total: 34.56,
    paymentStatus: 'completed',
    paymentMethod: 'Apple Pay',
    transactionId: 'TXN-2025-102',
    notes: 'Varsity Basketball — family ticket bundle',
    createdAt: new Date('2026-02-20T18:44:00'),
    completedAt: new Date('2026-02-20T18:44:30'),
    items: [
      {
        id: '1050e8400-e29b-41d4-a716-446655440102',
        orderId: '1000e8400-e29b-41d4-a716-446655440102',
        feeId: '850e8400-e29b-41d4-a716-446655440061',
        feeName: 'Varsity Basketball vs. Central High',
        feeCategory: 'Event Tickets',
        quantity: 4,
        pricingTier: 'full',
        unitPrice: 8.00,
        totalPrice: 32.00,
        createdAt: new Date('2026-02-20T18:44:00'),
      },
    ],
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440103',
    orderNumber: 'ORD-2025-00103',
    userId: '650e8400-e29b-41d4-a716-446655440006',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'parent',
    userName: 'Lisa Johnson',
    userEmail: 'lisa.johnson@email.com',
    subtotal: 65.00,
    tax: 5.20,
    total: 70.20,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2025-103',
    notes: 'Yearbook — partial payment (50%)',
    createdAt: new Date('2026-01-18T12:05:00'),
    completedAt: new Date('2026-01-18T12:05:32'),
    items: [
      {
        id: '1050e8400-e29b-41d4-a716-446655440103',
        orderId: '1000e8400-e29b-41d4-a716-446655440103',
        feeId: '850e8400-e29b-41d4-a716-446655440010',
        feeName: 'Yearbook',
        feeCategory: 'General Fees',
        quantity: 1,
        pricingTier: 'full',
        unitPrice: 65.00,
        totalPrice: 65.00,
        partialPaymentAmount: 32.50,
        createdAt: new Date('2026-01-18T12:05:00'),
      },
    ],
  },
  {
    id: '1000e8400-e29b-41d4-a716-446655440104',
    orderNumber: 'ORD-2025-00104',
    userId: '650e8400-e29b-41d4-a716-446655440006',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'parent',
    userName: 'Lisa Johnson',
    userEmail: 'lisa.johnson@email.com',
    subtotal: 150.00,
    tax: 12.00,
    total: 162.00,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    transactionId: 'TXN-2025-104',
    notes: 'Back-to-school bundle: uniform + activity pass',
    createdAt: new Date('2025-08-14T16:22:00'),
    completedAt: new Date('2025-08-14T16:22:51'),
    items: [
      {
        id: '1050e8400-e29b-41d4-a716-446655440104',
        orderId: '1000e8400-e29b-41d4-a716-446655440104',
        feeId: '850e8400-e29b-41d4-a716-446655440011',
        feeName: 'PE Uniform Set',
        feeCategory: 'General Fees',
        quantity: 2,
        pricingTier: 'full',
        unitPrice: 35.00,
        totalPrice: 70.00,
        createdAt: new Date('2025-08-14T16:22:00'),
      },
      {
        id: '1050e8400-e29b-41d4-a716-446655440105',
        orderId: '1000e8400-e29b-41d4-a716-446655440104',
        feeId: '850e8400-e29b-41d4-a716-446655440019',
        feeName: 'Student Activity Pass',
        feeCategory: 'Events & Activities',
        quantity: 1,
        pricingTier: 'full',
        unitPrice: 75.00,
        totalPrice: 75.00,
        createdAt: new Date('2025-08-14T16:22:00'),
      },
    ],
  },
];
